<template>
  <!-- 弹窗 -->
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    @ok="a_modal.handleOk"
  >
    {{ a_modal.content }}
  </a-modal>
  
  <div class="index_container">
    <div class="index_header">
      <h1>救援管理平台</h1>
      <p>案件自助服务中心</p>
    </div>

    <div class="table">
      <ul>
        <li v-if="table.signature" @click="goTo('order')">
          电子工单
        </li>
        <li v-if="table.location" @click="goTo('location')">
          上报定位
        </li>
        <li v-if="table.locale" @click="goTo('locale')">
          现场照片
        </li>
        <li v-if="table.rank" @click="goTo('rank')">
          客户评价
        </li>
      </ul>
    </div>

    <div class="index_footer">
      <div class="footer-copyright">版权所有 &copy; 2026 智能救援管理平台</div>
      <div class="footer-link"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备17138350号-4</a></div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const has_tip = localStorage.getItem('has_tip')
const a_modal = ref({
  cancelText: '取消', 
  content: '', 
  handleOk: null, 
  okText: '确定', 
  title: '', 
  visible: false, 
})
const table = ref({
  location: false,
  locale: false,
  signature: false,
  rank: false
})
const fetchData = () => {
  return axios.get(`https://api.gdpinganxing.com/api/cs?uuid=${uuid.value}`)
}
const goTo = (url) => {
  router.push(`/${url}/${uuid.value}`)
}

onMounted(async() => {
  if (!route.params.id) {
    a_modal.value.title = '* Tips：'
    a_modal.value.content = 'URL错误，请联系客服！'
    a_modal.value.visible = true
    a_modal.value.handleOk = () => {
      localStorage.setItem('has_tip', 1)
      a_modal.value.visible = false
    }
    return
  }
  uuid.value = route.params.id
  // 弹出欢迎窗口
  if (has_tip != 1) {
    a_modal.value.title = '* Tips：'
    a_modal.value.content = '请您上报信息，以便我们可以更好的为您提供服务！'
    a_modal.value.visible = true
    a_modal.value.handleOk = () => {
      localStorage.setItem('has_tip', 1)
      a_modal.value.visible = false
    }
  }
  const response = await fetchData()
  if (response.data.code != 200) {
    alert('获取案件信息失败...请联系客服...')
    return
  }
  if ('location' in response.data.data) {
    table.value.location = true
  }
  if ('locale' in response.data.data) {
    table.value.locale = true
  }
  if ('signature' in response.data.data) {
    table.value.signature = true
  }
  if ('rank' in response.data.data) {
    table.value.rank = true
  }
})
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  margin: 0;
  padding: 0;
  color: #666666;
  line-height: 1.5;
}
ul {
  list-style: none;
}
.index_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin-top: -64px;
  height: 100vh;
  position: relative;
}
.index_header {
  margin-right: auto;
  margin-left: auto;
  width: 208px;
}
.index_header > h1 {
  padding-bottom: 24px;
  color: #333333;
  text-align: center;
  border-bottom: 4px solid #cccccc;
}
.index_header > p {
  margin-top: 24px;
  color: #999999;
  text-align: center;
}
.table {
  width: 100%;
}
.table ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 64px;
  margin-right: 32px;
  margin-bottom: 0;
  margin-left: 32px;
  padding: 0;
  width: auto;
}
.table li {
  margin-bottom: 20px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  width: calc(50% - 20px);
  color: #ffffff;
  text-align: center;
  box-sizing: border-box;
  background-color: #1677ff;
  border-radius: 10px;
}
.index_footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-right: 0;
  padding-bottom: 20px;
  padding-left: 0;
  text-align: center;
  border-top: 1px dotted #cccccc;
}
.footer-copyright {
  margin-bottom: 10px;
  color: #999999;
  font-size: 14px;
}
.footer-link a {
  color: #1677ff;
  text-decoration: none;
  font-size: 14px;
}
</style>